import React, { useMemo } from 'react';
import { Segment, Radio, Checkbox } from 'tea-component';
import SvgIcon from '@home/components/SvgIcon';
import TimeChangeCheckbox from '@gp/components/TimeChangeCheckbox';
import { reportBtnOperationLog } from '@gp/utils/common';
import { CATEGORY_TYPE } from '@gp/constants/const';
import './index.scss';

const TopBarLeftElementCom = (props: any) => {
  const { activeTab, category, handleActiveTabChange, handleCategoryChange, filterLoading } = props;

  const isAllType = useMemo(() => {
    return category?.length === CATEGORY_TYPE?.length || category?.length === 0;
  }, [category]);

  const handleCategoryAllChange = () => {
    if (!isAllType) {
      handleCategoryChange([]);
    }
  };

  const handleCategoryAllChangeCur = (value: any) => {
    if (value?.length === CATEGORY_TYPE?.length) {
      handleCategoryChange([]);
    } else {
      handleCategoryChange(value);
    }
  };

  return (
    <>
      <Segment
        className="dbg-calendar-segment"
        value={activeTab}
        onChange={handleActiveTabChange}
        options={[
          {
            text: (
              <div className="dbg-svg-flex">
                <SvgIcon type="calendar-card" className="dbg-flex-icon" />
                <span className="dbg-svg-flex-text">Milestone Calendar</span>
              </div>
            ),
            value: 'calendar-card',
          },
          {
            text: (
              <div className="dbg-svg-flex">
                <SvgIcon type="calendar-table" className="dbg-flex-icon" />
                <span className="dbg-svg-flex-text">Review Meeting Schedule</span>
              </div>
            ),
            value: 'calendar-table',
          },
        ]}
      />

      <div className="dbg-calendar-operator">
        <Radio name="male" value={isAllType} onChange={handleCategoryAllChange}>
          All
        </Radio>

        <Checkbox.Group value={category} onChange={handleCategoryAllChangeCur}>
          <Checkbox name="gr">
            <div className="dbg-calendar-operator-check">
              <i
                className="dbg-schedule-calendar-legend-icon"
                style={{ backgroundColor: '#FFCCCC' }}
              ></i>
              GR
            </div>
          </Checkbox>
          <Checkbox name="check_in">
            <div className="dbg-calendar-operator-check">
              <i
                className="dbg-schedule-calendar-legend-icon"
                style={{ backgroundColor: '#A6C9FF' }}
              ></i>
              Check in
            </div>
          </Checkbox>
          <Checkbox name="launch">
            <div className="dbg-calendar-operator-check">
              <i
                className="dbg-schedule-calendar-legend-icon"
                style={{ backgroundColor: '#C0EBD2' }}
              ></i>
              Launch
            </div>
          </Checkbox>
          <Checkbox name="test">
            <div className="dbg-calendar-operator-check">
              <i
                className="dbg-schedule-calendar-legend-icon"
                style={{ backgroundColor: '#C0EBD2' }}
              ></i>
              Test
            </div>
          </Checkbox>
          <Checkbox name="others">
            <div className="dbg-calendar-operator-check">
              <i
                className="dbg-schedule-calendar-legend-icon"
                style={{ backgroundColor: '#C0EBD2' }}
              ></i>
              Others
            </div>
          </Checkbox>
        </Checkbox.Group>
      </div>
    </>
  );
};

export default React.memo(TopBarLeftElementCom);
